import React, { PureComponent } from 'react'
import ReactGA from 'react-ga'
import Collapse from 'react-bootstrap/Collapse'
import JeffLogo from '../../../assets/jefferson-health-logo.png'
import MenuItems from './MenuItems'
import './scoped.bootstrap.scss'
import './JeffHeader.scss'

class JeffHeader extends PureComponent {
  state = {
    mobileCollapsed: true,
    locCollapsed: true,
    careerCollapsed: true,
    giveCollapsed: true,
    centerCity: true,
    abington: true,
    northeast: true,
    newJersey: true
  }

  toggleCollapse = (key) => {
    switch (key) {
    case 'mobile':
      return this.setState({
        mobileCollapsed: !this.state.mobileCollapsed,
        locCollapsed: true,
        careerCollapsed: true,
        giveCollapsed: true
      })
    case 'location':
      return this.setState({
        locCollapsed: !this.state.locCollapsed,
        careerCollapsed: true,
        giveCollapsed: true,
        centerCity: true,
        abington: true,
        northeast: true,
        newJersey: true
      })
    case 'give':
      return this.setState({
        giveCollapsed: !this.state.giveCollapsed,
        careerCollapsed: true,
        locCollapsed: true
      })
    case 'career':
      return this.setState({
        careerCollapsed: !this.state.careerCollapsed,
        giveCollapsed: true,
        locCollapsed: true
      })
    default: {
      const isOpen = this.state[key]
      return this.setState({
        centerCity: true,
        abington: true,
        northeast: true,
        newJersey: true
      }, () => {
        this.setState({
          [key]: isOpen === false
        })
      })
    }
    }
  }

  componentDidMount() {
    document.addEventListener('mousedown', this.handleClick, false)
  }

  handleClick = e => {
    if (this.node.contains(e.target)) {
      return null
    }
    return this.setState({
      locCollapsed: true,
      careerCollapsed: true,
      giveCollapsed: true
    })
  }

  setLinkRef = (ref, key, fn) => {
    if (ref) {
      this[key] = ref
      this[key].addEventListener('auxclick', fn)
    } else {
      this[key].removeEventListener('auxclick', fn)
    }
  }

  trackLogoLink = () => this.trackLink('Click on Logo')

  trackUniLink = () => this.trackLink('Click to University')

  trackLink = (action = '', label = '') => {
    ReactGA.event({
      category: 'Navigation',
      action,
      label
    })
  }

  render() {
    const {
      mobileCollapsed,
      locCollapsed,
      careerCollapsed,
      giveCollapsed,
      centerCity,
      abington,
      northeast,
      newJersey
    } = this.state
    const { toggleCollapse, trackLink, setLinkRef, trackLogoLink, trackUniLink } = this
    return (
      <div
        className="bootstrap-scope"
        ref={node => { this.node = node }}
      >
        <nav
          id="global-navigation"
          className="navbar navbar-default"
          style={{ padding: '0px', zIndex: '1' }}
        >
          <div
            className="container"
            style={{ display: 'inherit' }}
          >
            <div className="navbar-header">
              <button
                type="button"
                className={mobileCollapsed ? 'navbar-toggle collapsed' : 'navbar-toggle open'}
                onClick={() => toggleCollapse('mobile')}
                aria-expanded={!mobileCollapsed}
              >
                <span className="sr-only">Toggle navigation</span>
                <span className="icon-bar"></span>
                <span className="icon-bar"></span>
                <span className="icon-bar"></span>
              </button>
              <a
                className="navbar-brand"
                href="http://www.jeffersonhealth.org"
                onClick={trackLogoLink}
                ref={ref => setLinkRef(ref, 'logoLink', trackLogoLink)}
              >
                <img
                  src={JeffLogo}
                  alt="Jefferson Health"
                />
              </a>
              <div className="brand-skcc">
                 Home of Sidney Kimmel Medical College
              </div>
            </div>
            <Collapse in={!mobileCollapsed}>
              <div
                id="bs-global-navbar-collapse"
                className={mobileCollapsed ? 'navbar-collapse collapse' : 'navbar-collapse collapse in'}
                aria-expanded={!mobileCollapsed}
              >
                <ul className="nav navbar-nav navbar-right">
                  <li className={`dropdown ${locCollapsed ? '' : 'open'}`}>
                    <a
                      href="#/"
                      className="nav-heading"
                      onClick={() => toggleCollapse('location')}
                      aria-expanded={!locCollapsed}
                    >
                    All Locations<span className="caret"></span>
                    </a>
                    <ul className="dropdown-menu dropdown-menu-left">
                      <li className={`dropdown dropdown-submenu ${centerCity ? '' : 'open'}`}>
                        <a
                          href="#/"
                          className="dropdown-toggle"
                          onClick={() => toggleCollapse('centerCity')}
                        >
                          Center City
                        </a>
                        <ul className="dropdown-menu">
                          <MenuItems
                            type="centerCity"
                            action="Click to Locations"
                            label="Center City"
                            onClick={trackLink}
                          />
                        </ul>
                      </li>
                      <li className={`dropdown dropdown-submenu ${abington ? '' : 'open'}`}>
                        <a
                          href="#/"
                          className="dropdown-toggle"
                          onClick={() => toggleCollapse('abington')}
                        >
                          Abington
                        </a>
                        <ul className="dropdown-menu">
                          <MenuItems
                            type="abbington"
                            action="Click to Locations"
                            label="Abington"
                            onClick={trackLink}
                          />
                        </ul>
                      </li>
                      <li className={`dropdown dropdown-submenu ${northeast ? '' : 'open'}`}>
                        <a
                          href="#/"
                          className="dropdown-toggle"
                          onClick={() => toggleCollapse('northeast')}
                        >
                          Northeast
                        </a>
                        <ul className="dropdown-menu">
                          <MenuItems
                            type="northEast"
                            action="Click to Locations"
                            label="Northeast"
                            onClick={trackLink}
                          />
                        </ul>
                      </li>
                      <li className={`dropdown dropdown-submenu menu-width ${newJersey ? '' : 'open'}`}>
                        <a
                          href="#/"
                          className="dropdown-toggle"
                          onClick={() => toggleCollapse('newJersey')}
                        >
                          New Jersey <span className="navlink-spacer"></span>
                        </a>
                        <ul className="dropdown-menu">
                          <MenuItems
                            type="newJersey"
                            action="Click to Locations"
                            label="New Jersey"
                            onClick={trackLink}
                          />
                        </ul>
                      </li>
                    </ul>
                  </li>
                  <li className={`dropdown ${careerCollapsed ? '' : 'open'}`}>
                    <a
                      href="#/"
                      className="nav-heading"
                      onClick={() => toggleCollapse('career')}
                      aria-expanded={!careerCollapsed}
                    >
                    Careers<span className="caret"></span>
                    </a>
                    <ul className="dropdown-menu dropdown-menu-left">
                      <MenuItems
                        type="careers"
                        action="Click to Careers"
                        onClick={trackLink}
                      />
                    </ul>
                  </li>
                  <li className={`dropdown ${giveCollapsed ? '' : 'open'}`}>
                    <a
                      href="#/"
                      className="nav-heading"
                      onClick={() => toggleCollapse('give')}
                      aria-expanded={!giveCollapsed}
                    >
                    Give Now<span className="caret"></span>
                    </a>
                    <ul className="dropdown-menu dropdown-menu-left">
                      <MenuItems
                        type="giveNow"
                        action="Click to Give Now"
                        onClick={trackLink}
                      />
                    </ul>
                  </li>
                  <li className="hidden-xs hidden-sm">
                    <div className="navbar-phone-1">
                      <a
                        onClick={() => trackLink('Click To Call', 'JeffNow')}
                        href="tel:180533669"
                      >CALL 1-800-JEFF-NOW</a>
                    </div>
                  </li>
                  <li>
                    <a
                      className="nav-heading"
                      href="http://www.jefferson.edu/university.html"
                      onClick={trackUniLink}
                      ref={ref => setLinkRef(ref, 'uniLink', trackUniLink)}
                      style={{ borderBottom: 0 }}
                    >UNIVERSITY</a>
                  </li>
                  <li
                    className="visible-xs visible-sm"
                    style={{ paddingTop: '20px' }}
                  >
                    <div className="navbar-phone-2">
                      <a
                        onClick={() => trackLink('Click To Call', 'JeffNow')}
                        href="tel:18005333669"
                      >1-800-JEFF-NOW</a>
                    </div>
                  </li>
                </ul>
              </div>
            </Collapse>
          </div>
        </nav>
      </div>
    )
  }
}

export default JeffHeader
